import * as permParametrage from '@/configuration/general/permissionsParametrageConf';
import * as permBodac from '@/configuration/permissionsBodacConf';
import * as permGabed from '@/configuration/gabed/permissionsGabedConf';
import * as permBaux from '@/configuration/baux/permissionsBauxConf';
import * as permLogistique from '@/configuration/logistique/permissionsLogistiqueConf';
import * as permPresse from '@/configuration/presse/permissionsPresseConf';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import store from '@/store/store';

export default function genererSectionParametrage() {
  return [
    {
      name: 'parametrage.categorie.affixe2',
      items: [
        {
          libelle: 'parametrage.sousCategorie.collaborateurs',
          class: 'logo logo_collaborateur',
          routeName: 'l.parametrage.collaborateurs',
          perm: permParametrage.COLLABORATEURS.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.societes',
          class: 'logo logo_ecrou',
          routeName: 'l.parametrage.societe/agence',
          perm: permParametrage.SOCIETES.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.role',
          class: 'logo logo_roles',
          routeName: 'l.parametrage.roles',
          perm: permParametrage.ROLES.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.secteurActivite',
          class: 'logo logo_ecrou',
          routeName: 'l.parametrage.secteur_activite',
          perm: permParametrage.SECTEUR_ACTIVITE.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.civilite',
          class: 'logo logo_ecrou',
          routeName: 'l.parametrage.civilite',
          perm: permParametrage.CIVILITE.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.motifBlocage',
          class: 'logo logo_ecrou',
          routeName: 'l.bodac.motif_blocage',
          perm: permBodac.MOTIF_BLOCAGE.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.edition',
          class: 'logo logo_ecrou',
          routeName: 'l.parametrage.edition',
          perm: permParametrage.PARAMETRAGE_EDITION.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.faceMotifNonCom',
          class: 'logo logo_ecrou',
          routeName: 'l.parametrage.face_motif_non_com',
          perm: permParametrage.FACE_MOTIF_NON_COM.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.typePointVente',
          class: 'logo logo_ecrou',
          routeName: 'l.parametrage.type_point_vente',
          perm: permParametrage.TYPE_POINT_VENTE.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.profilTiers',
          class: 'logo logo_ecrou',
          routeName: 'l.parametrage.profil_tiers',
          perm: permParametrage.PROFIL_TIERS.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.regimeTva',
          class: 'logo logo_ecrou',
          routeName: 'l.parametrage.regime_tva',
          perm: permParametrage.PARAMETRAGE_REGIME_TVA.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.indexation',
          class: 'logo logo_ecrou',
          routeName: 'm.parametrage.indexation',
          perm: permParametrage.INDEXATION.maj,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.typeContact',
          class: 'logo logo_ecrou',
          routeName: 'l.parametrage.type_contact',
          perm: permParametrage.TYPE_CONTACT.maj,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.regleFacturation',
          class: 'logo logo_ecrou',
          routeName: 'l.presse.regle_facturation',
          perm: permPresse.REGLE_FACTURATION.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.indiceEtValeur',
          class: 'logo logo_ecrou',
          routeName: 'l.baux.indice_et_valeur',
          perm: permBaux.INDICE_ET_VALEUR.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.tag',
          class: 'logo logo_ecrou',
          routeName: 'l.parametrage.tag',
          perm: permParametrage.TAG.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.nomenclatureType',
          class: 'logo logo_ecrou',
          routeName: 'l.parametrage.nomenclature_type',
          perm: permParametrage.NOMENCLATURE_TYPE.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.secteur',
          class: 'logo logo_ecrou',
          routeName: 'l.parametrage.secteur',
          perm: permParametrage.SECTEUR.maj,
          actif: true,
          show: store.getters['parametres/parametresInterne'](PARAMETRES_INTERNE_KEYS.moduleSecteur.key),
        },
        {
          libelle: 'parametrage.sousCategorie.pays',
          class: 'logo logo_ecrou',
          routeName: 'l.parametrage.pays',
          perm: permParametrage.PAYS.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.fonctionContact',
          class: 'logo logo_ecrou',
          routeName: 'l.parametrage.fonction_contact',
          perm: permParametrage.FONCTION_CONTACT.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.service',
          class: 'logo logo_ecrou',
          routeName: 'l.parametrage.service',
          perm: permParametrage.SERVICE.lecture,
          actif: true,
          show: true,
        },
      ],
    },
    {
      name: 'parametrage.categorie.comptabilite',
      items: [
        {
          libelle: 'parametrage.sousCategorie.domiciliationBancaire',
          class: 'logo logo_domiciliation_bancaire',
          routeName: 'l.parametrage.domiciliation_bancaire',
          perm: permParametrage.DOMICILIATIONS_BANCAIRES.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.schemaComptable',
          class: 'logo logo_schema_comptable',
          routeName: 'l.parametrage.schema_comptable',
          perm: permParametrage.SCHEMA_COMPTABLE.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.modeReglement',
          class: 'logo logo_mode_reglement',
          routeName: 'l.parametrage.mode_reglement',
          perm: permParametrage.MODE_REGLEMENT.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.delaiReglement',
          class: 'logo logo_ecrou',
          routeName: 'l.parametrage.delai_reglement',
          perm: permParametrage.DELAI_REGLEMENT.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.natureProduit',
          class: 'logo logo_nature_produit',
          routeName: 'l.parametrage.support_commercial',
          perm: permParametrage.SUPPORT_COMMERCIAL.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.compteAnalytique',
          class: 'logo logo_ecrou',
          routeName: 'l.parametrage.compte_analytique',
          perm: permParametrage.COMPTE_ANALYTIQUE.lecture,
          actif: true,
          show: true,
        },
      ],
    },
    {
      name: 'parametrage.categorie.gestCom',
      items: [
        {
          libelle: 'parametrage.sousCategorie.commentaire',
          class: 'logo logo_commentaire',
          routeName: 'l.parametrage.commentaire',
          perm: permParametrage.COMMENTAIRE.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.format',
          class: 'logo logo_ecrou',
          routeName: 'l.bodac.format',
          perm: permBodac.FORMAT.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.typeReseau',
          class: 'logo logo_ecrou',
          routeName: 'l.bodac.type_reseau',
          perm: permBodac.TYPE_RESEAU.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.categorieGroupeProduitDeductible',
          class: 'logo logo_ecrou',
          routeName: 'l.parametrage.categorie_groupe_produit_deductible',
          perm: permParametrage.CATEGORIE_GROUPE_PRODUIT_DEDUCTIBLE.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.libelle_remise',
          class: 'logo logo_ecrou',
          routeName: 'l.parametrage.libelle_remise',
          perm: permParametrage.LIBELLE_REMISE.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.motifAnnulationReglement',
          class: 'logo logo_ecrou',
          routeName: 'l.parametrage.motif_annulation_reglement',
          perm: permParametrage.MOTIF_ANNULATION_REGLEMENT.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.marque',
          class: 'logo logo_ecrou',
          routeName: 'l.parametrage.marque',
          perm: permParametrage.MARQUE.lecture,
          actif: true,
          show: true,
        },
      ],
    },
    {
      name: 'parametrage.categorie.achat',
      items: [
        {
          libelle: 'parametrage.sousCategorie.competenceFournisseur',
          class: 'logo logo_ecrou',
          routeName: 'l.parametrage.competence_fournisseur',
          perm: permParametrage.COMPETENCE_FOURNISSEUR.lecture,
          actif: true,
          show: true,
        },
      ],
    },
    {
      name: 'parametrage.categorie.impressionAffiche',
      items: [
        {
          libelle: 'parametrage.sousCategorie.natureSupportAffiche',
          class: 'logo logo_ecrou',
          routeName: 'l.parametrage.nature_support_affiche',
          perm: permParametrage.NATURE_SUPPORT_AFFICHE.lecture,
          actif: true,
          show: store.getters['parametres/parametresInterne'](PARAMETRES_INTERNE_KEYS.moduleLogistiqueImpression.key),
        },
        {
          libelle: 'parametrage.sousCategorie.formatAffiche',
          class: 'logo logo_ecrou',
          routeName: 'l.bodac.format_affiche',
          perm: permBodac.FORMAT_AFFICHE.lecture,
          actif: true,
          show: store.getters['parametres/parametresInterne'](PARAMETRES_INTERNE_KEYS.moduleLogistiqueImpression.key),
        },
      ],
    },
    {
      name: 'parametrage.categorie.patrimoine',
      items: [
        {
          libelle: 'parametrage.sousCategorie.dispositifSupport',
          class: 'logo logo_ecrou',
          routeName: 'l.gabed.dispositif_support',
          perm: permGabed.DISPOSITIF_SUPPORT.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.dispositifType',
          class: 'logo logo_ecrou',
          routeName: 'l.gabed.dispositif_type',
          perm: permGabed.DISPOSITIF_TYPE.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.materielLocalisation',
          class: 'logo logo_ecrou',
          routeName: 'l.gabed.materiel_localisation',
          perm: permGabed.MATERIEL_LOCALISATION.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.materielAngleVision',
          class: 'logo logo_ecrou',
          routeName: 'l.gabed.materiel_angle_vision',
          perm: permGabed.MATERIEL_ANGLE_VISON.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.materielFormat',
          class: 'logo logo_ecrou',
          routeName: 'l.gabed.materiel_format',
          perm: permGabed.MATERIEL_FORMAT.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.materielType',
          class: 'logo logo_ecrou',
          routeName: 'l.gabed.materiel_type',
          perm: permGabed.MATERIEL_TYPE.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.typeTaxationTlpe',
          class: 'logo logo_ecrou',
          routeName: 'l.gabed.type_taxation_tlpe',
          perm: permGabed.TYPE_TAXATION_TLPE.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.accessoire',
          class: 'logo logo_ecrou',
          routeName: 'l.gabed.accessoire',
          perm: permGabed.ACCESSOIRE.lecture,
          actif: true,
          show: true,
        },
      ],
    },
    {
      name: 'parametrage.categorie.baux',
      items: [
        {
          libelle: 'parametrage.sousCategorie.contratNature',
          class: 'logo logo_ecrou',
          routeName: 'l.baux.contrat_nature',
          perm: permBaux.CONTRAT_NATURE.lecture,
          actif: true,
          show: true,
        },
        {
          libelle: 'parametrage.sousCategorie.contratSignataire',
          class: 'logo logo_ecrou',
          routeName: 'l.baux.signataire',
          perm: permBaux.CONTRAT_SIGNATAIRE.lecture,
          actif: true,
          show: true,
        },
      ],
    },
    {
      name: 'parametrage.categorie.presse',
      items: [
        {
          libelle: 'parametrage.sousCategorie.typeProduit',
          class: 'logo logo_ecrou',
          routeName: 'l.presse.type_produit',
          perm: permPresse.TYPE_PRODUIT.lecture,
          actif: true,
          show: store.getters['parametres/parametresInterne'](PARAMETRES_INTERNE_KEYS.modulePresse.key),
        },
        {
          libelle: 'parametrage.sousCategorie.couleurEncart',
          class: 'logo logo_ecrou',
          routeName: 'l.presse.couleur_encart',
          perm: permPresse.COULEUR_ENCART.lecture,
          actif: true,
          show: store.getters['parametres/parametresInterne'](PARAMETRES_INTERNE_KEYS.produitPresse.key),
        },
        {
          libelle: 'parametrage.sousCategorie.emplacementPresse',
          class: 'logo logo_ecrou',
          routeName: 'l.presse.emplacement_presse',
          perm: permPresse.EMPLACEMENT_PRESSE.lecture,
          actif: true,
          show: store.getters['parametres/parametresInterne'](PARAMETRES_INTERNE_KEYS.produitPresse.key),
        },
        {
          libelle: 'parametrage.sousCategorie.periodicite',
          class: 'logo logo_ecrou',
          routeName: 'l.presse.periodicite',
          perm: permPresse.PERIODICITE.lecture,
          actif: true,
          show: store.getters['parametres/parametresInterne'](PARAMETRES_INTERNE_KEYS.produitPresse.key),
        },
        {
          libelle: 'parametrage.sousCategorie.surface',
          class: 'logo logo_ecrou',
          routeName: 'l.presse.surface',
          perm: permPresse.SURFACE.lecture,
          actif: true,
          show: store.getters['parametres/parametresInterne'](PARAMETRES_INTERNE_KEYS.produitPresse.key),
        },
        {
          libelle: 'parametrage.sousCategorie.modeDistribution',
          class: 'logo logo_ecrou',
          routeName: 'l.presse.mode_distribution',
          perm: permPresse.MODE_DISTRIBUTION.lecture,
          actif: true,
          show: store.getters['parametres/parametresInterne'](PARAMETRES_INTERNE_KEYS.produitPresse.key),
        },
        {
          libelle: 'parametrage.sousCategorie.typeFormatPresse',
          class: 'logo logo_ecrou',
          routeName: 'l.presse.type_format_presse',
          perm: permPresse.TYPE_FORMAT_PRESSE.lecture,
          actif: true,
          show: store.getters['parametres/parametresInterne'](PARAMETRES_INTERNE_KEYS.produitPresse.key),
        },
        {
          libelle: 'parametrage.sousCategorie.typeEvenementSponsoring',
          class: 'logo logo_ecrou',
          routeName: 'l.presse.type_evenement_sponsoring',
          perm: permPresse.TYPE_EVENEMENT_SPONSORING.lecture,
          actif: true,
          show: store.getters['parametres/parametresInterne'](PARAMETRES_INTERNE_KEYS.produitSponsoring.key),
        },
        {
          libelle: 'parametrage.sousCategorie.typeEvenement',
          class: 'logo logo_ecrou',
          routeName: 'l.presse.type_evenement_pm',
          perm: permPresse.TYPE_EVENEMENT.lecture,
          actif: true,
          show: store.getters['parametres/parametresInterne'](PARAMETRES_INTERNE_KEYS.modulePresse.key),
        },
        {
          libelle: 'parametrage.sousCategorie.editionBat',
          class: 'logo logo_ecrou',
          routeName: 'm.parametrage.societe/agence-edition-bat',
          perm: permParametrage.SOCIETES.maj,
          actif: true,
          show: store.getters['parametres/parametresInterne'](PARAMETRES_INTERNE_KEYS.produitPresse.key),
        },
        {
          libelle: 'parametrage.sousCategorie.mailBat',
          class: 'logo logo_ecrou',
          routeName: 'm.parametrage.societe/agence-mail-bat',
          perm: permParametrage.SOCIETES.maj,
          actif: true,
          show: store.getters['parametres/parametresInterne'](PARAMETRES_INTERNE_KEYS.produitPresse.key),
        },
        {
          libelle: 'parametrage.sousCategorie.etatSuiviAdministratif',
          class: 'logo logo_ecrou',
          routeName: 'l.presse.etat_suivi_administratif',
          perm: permPresse.ETAT_SUIVI_ADMINISTRATIF.lecture,
          actif: true,
          show: store.getters['parametres/parametresInterne'](PARAMETRES_INTERNE_KEYS.produitPresse.key),
        },
      ],
    },
    {
      name: 'parametrage.categorie.logistique',
      items: [
        {
          libelle: 'parametrage.sousCategorie.typeOt',
          class: 'logo logo_ecrou',
          routeName: 'l.logistique.type_ot',
          perm: permLogistique.TYPE_OT.lecture,
          actif: true,
          show: store.getters['parametres/parametresInterne'](PARAMETRES_INTERNE_KEYS.afficherLogistiqueTechnique.key),
        },
      ],
    },
  ];
}
